/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Suggest_RowInputs */

const en_us2_translation_suggest_row = /** @type {(inputs: Translation_Suggest_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest a translation`)
};

const pt_br2_translation_suggest_row = /** @type {(inputs: Translation_Suggest_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir uma tradução`)
};

const es_419_translation_suggest_row = /** @type {(inputs: Translation_Suggest_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir una traducción`)
};

const pt_pt2_translation_suggest_row = /** @type {(inputs: Translation_Suggest_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerir uma tradução`)
};

const fr_fr2_translation_suggest_row = /** @type {(inputs: Translation_Suggest_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggérer une traduction`)
};

const de_de2_translation_suggest_row = /** @type {(inputs: Translation_Suggest_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung vorschlagen`)
};

const it_it2_translation_suggest_row = /** @type {(inputs: Translation_Suggest_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerisci una traduzione`)
};

/**
* | output |
* | --- |
* | "Suggest a translation" |
*
* @param {Translation_Suggest_RowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const translation_suggest_row = /** @type {((inputs?: Translation_Suggest_RowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Suggest_RowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_translation_suggest_row(inputs)
	if (locale === "es-419") return es_419_translation_suggest_row(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_suggest_row(inputs)
	if (locale === "fr-FR") return fr_fr2_translation_suggest_row(inputs)
	if (locale === "de-DE") return de_de2_translation_suggest_row(inputs)
	if (locale === "it-IT") return it_it2_translation_suggest_row(inputs)
	return en_us2_translation_suggest_row(inputs)
});
export { translation_suggest_row as "translation.suggest_row" }